module.exports = __webpack_public_path__ + "static/media/mr.ebf98c97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mr.png
// module id = 1929
// module chunks = 0